module.exports = __webpack_public_path__ + "static/media/80.4546adc8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/80.svg
// module id = 170
// module chunks = 0